import { render, staticRenderFns } from "./opcFederal.vue?vue&type=template&id=c6557928"
import script from "./opcFederal.vue?vue&type=script&lang=js"
export * from "./opcFederal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports